import { render, staticRenderFns } from "./SmartTags.vue?vue&type=template&id=0b0da6d7"
import script from "./SmartTags.vue?vue&type=script&lang=js"
export * from "./SmartTags.vue?vue&type=script&lang=js"
import style0 from "./SmartTags.vue?vue&type=style&index=0&id=0b0da6d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports